import { render, staticRenderFns } from "./MessagesLivePaused.vue?vue&type=template&id=11f26726&"
import script from "./MessagesLivePaused.vue?vue&type=script&lang=js&"
export * from "./MessagesLivePaused.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports